import { render, staticRenderFns } from "./InspectionRecordItemList.vue?vue&type=template&id=7deffb9f&scoped=true&"
import script from "./InspectionRecordItemList.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordItemList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRecordItemList.vue?vue&type=style&index=0&id=7deffb9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deffb9f",
  null
  
)

export default component.exports